import { Box, Typography } from '@mui/material';
import type { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

export const ReportsTemplateSectionTitle: FC<Props> = ({ children }) => {
  return (
    <Box
      sx={{
        display: 'inline-block', // shrink to fit content
        backgroundColor: '#026670',
        padding: '4px 12px', // tighter padding
        width: 'fit-content'
      }}
    >
      <Typography
        variant="h4"
        component="span" // Ensures inline behavior
        sx={{
          display: 'inline',
          fontWeight: 800,
          color: 'white',
          m: 0,
          fontSize: 12,
          textTransform: 'uppercase'
        }}
      >
        {children}
      </Typography>
    </Box>
  );
};

export const ReportsTemplateSubsectionTitle: FC<Props> = ({ children }) => {
  return (
    <Box sx={{ display: 'inline-block', mb: 2 }}>
      <Typography
        variant="h5"
        sx={{
          fontWeight: 400,
          color: '#4A8086',
          display: 'inline-block'
        }}
      >
        {children}
      </Typography>
      <Box
        sx={{
          height: '2px',
          backgroundColor: '#BFD6D9',
          marginTop: '2px',
          width: '20%'
        }}
      />
    </Box>
  );
};

export default ReportsTemplateSectionTitle;
